import { RESET } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default () => companyUsersActions[RESET]();
